import { SET_TRANSACTION_DATA } from './transactions';
import { RESET_STATE } from '../../../reducer';

export const SET_SEARCH_FILTER = 'merchantTransactions/SET_SEARCH_FILTER';
export const SET_COMMISSION_STATUS_FILTER =
  'merchantTransactions/SET_COMMISSION_STATUS_FILTER';
export const TOGGLE_CALENDAR_FILTER =
  'merchantTransactions/TOGGLE_CALENDAR_FILTER';
export const CLEAR_CALENDAR_FILTER =
  'merchantTransactions/CLEAR_CALENDAR_FILTER';
export const SET_CALENDAR_START_FILTER =
  'merchantTransactions/SET_CALENDAR_START_FILTER';
export const SET_CALENDAR_END_FILTER =
  'merchantTransactions/SET_CALENDAR_END_FILTER';
export const SET_CALENDAR_SAGA = 'merchantTransactions/SET_CALENDAR_SAGA';
export const SET_PER_PAGE_FILTER = 'merchantTransactions/SET_PER_PAGE_FILTER';
export const CHANGE_PAGINATOR_PAGE =
  'merchantTransactions/CHANGE_PAGINATOR_PAGE';

export const setSearchFilter = searchValue => ({
  type: SET_SEARCH_FILTER,
  searchValue
});

export const setCommissionStatusFilter = status => ({
  type: SET_COMMISSION_STATUS_FILTER,
  status
});

export const toggleCalendarFilter = () => ({
  type: TOGGLE_CALENDAR_FILTER
});

export const clearCalendarFilter = () => ({
  type: CLEAR_CALENDAR_FILTER
});

export const setCalendarStartFilter = calendarStart => ({
  type: SET_CALENDAR_START_FILTER,
  calendarStart
});

export const setCalendarEndFilter = calendarEnd => ({
  type: SET_CALENDAR_END_FILTER,
  calendarEnd
});

export const setCalendarSaga = () => ({
  type: SET_CALENDAR_SAGA
});

export const setPerPageFilter = perPage => ({
  type: SET_PER_PAGE_FILTER,
  perPage
});
export const changePage = pageNumber => ({
  type: CHANGE_PAGINATOR_PAGE,
  pageNumber
});

const initialState = {
  commissionStatus: null,
  emailStatus: null,
  search: '',
  calendarFilterState: false,
  startDate: null,
  endDate: null,
  perPage: 10,
  currentPage: 1,
  // visitedPages: [1],
  pageCount: 0,
  previouslyVisited: [1]
};

const resetPageState = {
  currentPage: 1,
  // visitedPages: [1],
  previouslyVisited: [1]
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TRANSACTION_DATA:
      return {
        ...state,
        pageCount: Math.ceil(action.payload.commissions_count / state.perPage)
      };
    case SET_SEARCH_FILTER:
      return {
        ...state,
        search: action.searchValue,
        ...resetPageState
      };
    case SET_COMMISSION_STATUS_FILTER:
      return {
        ...state,
        commissionStatus: action.status,
        ...resetPageState
      };
    case TOGGLE_CALENDAR_FILTER:
      return {
        ...state,
        calendarFilterState: !state.calendarFilterState,
        ...resetPageState
      };
    case SET_CALENDAR_START_FILTER:
      return {
        ...state,
        startDate: action.calendarStart
      };
    case SET_CALENDAR_END_FILTER:
      return {
        ...state,
        endDate: action.calendarEnd,
        ...resetPageState
      };
    case CLEAR_CALENDAR_FILTER:
      return {
        ...state,
        startDate: null,
        endDate: null,
        ...resetPageState
      };
    case SET_PER_PAGE_FILTER:
      return {
        ...state,
        perPage: action.perPage,
        ...resetPageState
      };
    case CHANGE_PAGINATOR_PAGE:
      return {
        ...state,
        currentPage: action.pageNumber,
        expandedRow: null,
        previouslyVisited: state.previouslyVisited.includes(action.pageNumber)
          ? state.previouslyVisited
          : [...state.previouslyVisited, action.pageNumber]
      };
    case RESET_STATE:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
